import { Loader } from '@pwc/pwc-deals-ui';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  fetchSurveyResponses,
  getQuestion,
  getQuestionById,
  getSurveyResponses,
  getResetAnswersStatus,
  resetResetAnswersStatus,
} from '../../surveySlice';
import Question from '../Question/Question';

const SurveySection = ({ questionId }) => {
  const dispatch = useDispatch();
  const { projectId } = useParams();

  const question = useSelector(getQuestion);
  const surveyResponses = useSelector(getSurveyResponses);
  const { success: resetAnswerSuccess } = useSelector(getResetAnswersStatus);

  useEffect(() => {
    if (!surveyResponses) {
      dispatch(fetchSurveyResponses(projectId));
    }
  }, [dispatch, projectId, surveyResponses]);

  useEffect(() => {
    if (surveyResponses && (!question || question.id !== questionId)) {
      dispatch(getQuestionById(questionId));
    }
  }, [questionId, dispatch, question, surveyResponses]);

  useEffect(() => {
    if (resetAnswerSuccess) {
      dispatch(resetResetAnswersStatus());
    }
  }, [dispatch, resetAnswerSuccess]);

  return (
    <>
      {surveyResponses && question && <Question question={question} />}
      {(!surveyResponses || !question) && <Loader />}
    </>
  );
};

export default SurveySection;
